import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { useAddRequestMaterial } from '@features/AddRequestMaterial/lib/hooks/useAddRequestMaterial';
import { AddRequestMaterialModal } from '@features/AddRequestMaterialModal';
import { ToastManager } from '@features/ToastManager';
import { Flex, Icon, UiButton } from '@shared/ui';

import cls from './AddRequestMaterial.module.css';

export const AddRequestMaterial = () => {
    const { t } = useTranslation();

    const { isCreateModalOpen, onOpenAddModal, onCloseAddModal } = useAddRequestMaterial();

    return (
        <Flex align="center">
            <UiButton
                btnText={t('AddRequestMaterial.return.Flex.UiButton.btnText')}
                startIcon={<Icon iconName="plus" width={10} height={10} />}
                onClick={onOpenAddModal}
            />

            {isCreateModalOpen && (
                <AddRequestMaterialModal isOpen={isCreateModalOpen} onClose={onCloseAddModal} />
            )}
            <ToastManager
                toastPosition="left"
                pushStyles={cls.toastStyles}
                renderToast={({ isToastShow, positionStyles, text }) => (
                    <div
                        className={cn(cls.customToastContainer, isToastShow && cls.isOpen)}
                        style={positionStyles}
                    >
                        <Icon iconName="isChecked" />
                        <span className={cls.customToastContent}>{text}</span>
                    </div>
                )}
            />
        </Flex>
    );
};
